import { HashTable } from './../general/hashTable';
export class User {
    public userId: string;
    public name: string;
    public accessToken: string;
    public claims: HashTable<string> ={};
}